'use client';

import dynamic from 'next/dynamic';
import Link from 'next/link';
import { openApiSpec } from '@/openapi-spec';

// Dynamically import ReDoc to avoid SSR issues
const RedocStandalone = dynamic(() => import('redoc').then(mod => ({ default: mod.RedocStandalone })), {
  ssr: false,
  loading: () => <div className="flex items-center justify-center min-h-screen">Loading API Documentation...</div>
});

export default function SwaggerPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">API Documentation</h1>
              <p className="mt-2 text-sm text-gray-600">
                Interactive API documentation for the AI RAG system
              </p>
            </div>
            <div className="flex items-center space-x-4">
              <Link
                href="/"
                className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Back to Home
              </Link>
              <a
                href="/openapi.json"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Download OpenAPI Spec
              </a>
            </div>
          </div>
        </div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow">
          <RedocStandalone
            spec={openApiSpec}
            options={{
              theme: {
                colors: {
                  primary: {
                    main: '#3b82f6' // indigo-600
                  }
                },
                typography: {
                  fontSize: '14px',
                  lineHeight: '1.5em'
                }
              },
              expandResponses: '200,201',
              hideDownloadButton: false,
              hideHostname: false,
              hideLoading: false,
              jsonSampleExpandLevel: 2,
              maxDisplayedEnumValues: 3,
              menuToggle: true,
              scrollYOffset: 0,
              showExtensions: true,
              showObjectSchemaExamples: true
            }}
          />
        </div>
      </div>
    </div>
  );
}
